export enum ErrorCategory {
  Network = 'network',
  Validation = 'validation',
  Authentication = 'authentication',
  Authorization = 'authorization',
  NotFound = 'not_found',
  Server = 'server',
  UpstreamUnavailable = 'upstream_unavailable',
  Unknown = 'unknown',
}

export interface AppError {
  category: ErrorCategory;
  message: string;
  code?: string;
  statusCode?: number;
  originalError?: unknown;
  context?: string;
  timestamp: Date;
}

export interface ApiErrorBody {
  code?: string;
  message?: string;
}

export interface ApiErrorResponse {
  code?: string;
  message?: string;
  error?: string;
  status?: number;
  statusCode?: number;
}